import React from "react";
import { FaGithubSquare, FaLinkedin } from "react-icons/fa";
import { MdLocationPin } from "react-icons/md";

export default function Footer() {
  return (
    <div className="md:py-20 py-10">
      <div className="container px-4 mx-auto text-neutral-900 dark:text-neutral-100 flex flex-wrap justify-between items-center">
        <div className="w-full sm:w-auto flex gap-1 justify-center sm:justify-start items-center">
          <a
            href="https://goo.gl/maps/EaeJt2zw3SZKqXmA6"
            target="_blank"
            rel="noreferrer"
            className="cursor-pointer"
          >
            <MdLocationPin size={30} />
          </a>
          <p className="text-xl sm:text-2xl text-center">
            Bishwanath, Sylhet, Bangladesh
          </p>
        </div>
        <div className="order-1 lg:order-none w-full text-center border-t lg:border-none pt-5 lg:pt-0 mt-5 lg:mt-0 lg:w-auto">
          <p className="text-xl sm:text-2xl">&copy; 2023 Salman Ahmed</p>
        </div>
        <div className="w-full sm:w-auto">
          <ul className="flex justify-center mt-4 font-medium gap-4 md:mt-0 items-center">
            <li>
              <a
                href="https://github.com/shSalman009"
                target="_blank"
                rel="noreferrer"
                className="block bg-transparent transition duration-300 py-2 text-3xl text-neutral-700 hover:text-neutral-800  dark:text-neutral-300 dark:hover:text-neutral-100"
              >
                <FaGithubSquare />
              </a>
            </li>
            <li>
              <a
                href="https://www.linkedin.com/in/salman-ahmed-77682823b/"
                target="_blank"
                rel="noreferrer"
                className="block bg-transparent transition duration-300 py-2 text-3xl text-neutral-700 hover:text-neutral-800 dark:text-neutral-300 dark:hover:text-neutral-100"
              >
                <FaLinkedin />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
